import {toString, get} from '@servicenow/ui-internal';
import toAttributeName from './toAttributeName';
import {isSelector} from '../property-selectors';

export default function getInitialPropertyValue(el, key, propertyDefs = {}) {
	if (propertyDefs[key] && propertyDefs[key].readOnly) return propertyDefs[key].default;

	const property = el[key];
	const attr = toAttributeName(key);
	const unstablePreserveEmptyStr =
		(propertyDefs[key] && propertyDefs[key].unstablePreserveEmptyStr) || false;

	if (key !== 'style' && el.hasAttribute(attr) && !isSelector(property)) {
		const value = el.getAttribute(attr);
		const preserve =
			unstablePreserveEmptyStr || get(propertyDefs, `[${key}].schema.type`) === 'string';

		return value || (preserve ? value : true);
	}

	// property.toString() will return [object CSSStyleDeclaration] if the style property is a true style property
	// vs. a style object (key, value) that is passed via JSX in the view layer
	return key === 'style'
		? toString(property) === '[object Object]'
			? property
			: undefined
		: property;
}
